import { FC, useEffect, useState } from 'react';
import { Button, CheckboxInput, SlideOver, Search } from '@GxT-Team/gxt-components';
import { CatalogItemSlideOverMenuProps } from '../pages/CatalogTemplateForm/types';
import { SourceFileGroup } from '../pages/upload';
const CatalogItemSlideOver: FC<CatalogItemSlideOverMenuProps> = ({
  isOpen,
  onClose,
  heading,
  catalogItems,
  selectedItems,
  handleAdd,
  handleResetSelection,
  isSingleSelect = false,
  isLoading = false,
}) => {
  const [tempSelectedItems, setTempSelectedItems] = useState<SourceFileGroup[]>(
    selectedItems || [],
  );
  const [filteredItems, setFilteredItems] = useState(catalogItems);

  const handleSearchChange = (term: string) => {
    setFilteredItems(
      term.trim() === ''
        ? catalogItems
        : catalogItems.filter((item) => item.name.toLowerCase().includes(term.toLowerCase())),
    );
  };

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    name: string,
    id: number,
  ) => {
    if (isSingleSelect) {
      setTempSelectedItems([{ name, id }]);
    } else if (event.target.checked) {
      setTempSelectedItems((prev) => [...prev, { name, id }]);
    } else {
      setTempSelectedItems((prev) => prev.filter((item) => item.id !== id));
    }
  };

  const handleAddClick = () => {
    handleAdd(tempSelectedItems);
    onClose();
  };

  const handleClearSelection = () => {
    setTempSelectedItems([]);
    handleResetSelection();
  };

  const handleBackClick = () => {
    setTempSelectedItems([]);
    onClose();
  };

  useEffect(() => {
    setFilteredItems(catalogItems);
  }, [catalogItems]);

  return (
    <SlideOver isOpen={isOpen} onClose={onClose} mountElementId="styled-wrapper" width="28rem">
      <SlideOver.Header className="flex p-6 flex-col items-start gap-2 self-stretch bg-primary-50 text-system-50">
        {heading}
      </SlideOver.Header>
      {isLoading && <div>Loading...</div>}
      <div
        className="flex flex-col space-y-5 max-h-[75vh] overflow-auto w-full scroll-smooth"
        style={{
          scrollbarWidth: 'thin',
        }}>
        {catalogItems.length > 5 && (
          <div className="flex w-full pr-2">
            <Search onChangeCallback={handleSearchChange} placeholder="Search..." />
          </div>
        )}
        {filteredItems.map((item: SourceFileGroup) => (
          <div key={item.name} className="flex space-x-2">
            <CheckboxInput
              type="checkbox"
              id={`ctdSection-${item.name}`}
              value={item.name}
              $inputSize="xs"
              checked={tempSelectedItems.some((itemObj) => itemObj.id === item.id)}
              onChange={(e) => handleCheckboxChange(e, item.name, item.id)}
            />
            <p className="text-[#414141]">{item.name}</p>
          </div>
        ))}
      </div>
      <SlideOver.Footer className="flex items-center self-stretch">
        <div className="w-full">
          <Button variant="secondary" onClick={handleClearSelection}>
            Clear Selection
          </Button>
        </div>
        <div className="flex gap-4 justify-end items-center flex-grow flex-shrink flex-basis-0 w-full">
          <Button variant="primary" onClick={handleAddClick}>
            Add
          </Button>
          <Button variant="secondary" onClick={handleBackClick}>
            Back
          </Button>
        </div>
      </SlideOver.Footer>
    </SlideOver>
  );
};

export default CatalogItemSlideOver;
